import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'suitabilityFilter',
    pure: false,
})
export class SuitabilityPipe implements PipeTransform {

    public transform(items: any[], filter: any): any {
        if (!items || !filter) return items;

        return items
            .filter((item) => (item.subQuestionID === filter))
            .sort((a, b) => a.answerID - b.answerID);
    }
}
